export enum ILeaveActionTypes {
  FETCH_LEAVE_LIST_REQUEST = "FETCH_LEAVE_LIST_REQUEST",
  FETCH_LEAVE_LIST_SUCCESS = "FETCH_LEAVE_LIST_SUCCESS",
  FETCH_LEAVE_LIST_FAILURE = "FETCH_LEAVE_LIST_FAILURE",

  FETCH_LEAVE_ADMIN_LIST_REQUEST = "FETCH_LEAVE_ADMIN_LIST_REQUEST",
  FETCH_LEAVE_ADMIN_LIST_SUCCESS = "FETCH_LEAVE_ADMIN_LIST_SUCCESS",
  FETCH_LEAVE_ADMIN_LIST_FAILURE = "FETCH_LEAVE_ADMIN_LIST_FAILURE",

  FETCH_LOP_LIST_REQUEST = "FETCH_LOP_LIST_REQUEST",
  FETCH_LOP_LIST_SUCCESS = "FETCH_LOP_LIST_SUCCESS",
  FETCH_LOP_LIST_FAILURE = "FETCH_LOP_LIST_FAILURE",

  FETCH_LEAVE_TYPES_REQUEST = "FETCH_LEAVE_TYPES_REQUEST",
  FETCH_LEAVE_TYPES_SUCCESS = "FETCH_LEAVE_TYPES_SUCCESS",
  FETCH_LEAVE_TYPES_FAILURE = "FETCH_LEAVE_TYPES_FAILURE",

  FETCH_LEAVE_APPROVAL_WORKFLOW_LIST_REQUEST = "FETCH_LEAVE_APPROVAL_WORKFLOW_LIST_REQUEST",
  FETCH_LEAVE_APPROVAL_WORKFLOW_LIST_SUCCESS = "FETCH_LEAVE_APPROVAL_WORKFLOW_LIST_SUCCESS",
  FETCH_LEAVE_APPROVAL_WORKFLOW_LIST_FAILURE = "FETCH_LEAVE_APPROVAL_WORKFLOW_LIST_FAILURE",

  FETCH_LEAVE_EMPLOYEEL_WORKFLOW_LIST_REQUEST = "FETCH_LEAVE_EMPLOYEEL_WORKFLOW_LIST_REQUEST",
  FETCH_LEAVE_EMPLOYEEL_WORKFLOW_LIST_SUCCESS = "FETCH_LEAVE_EMPLOYEEL_WORKFLOW_LIST_SUCCESS",
  FETCH_LEAVE_EMPLOYEEL_WORKFLOW_LIST_FAILURE = "FETCH_LEAVE_EMPLOYEEL_WORKFLOW_LIST_FAILURE",
}

export type ILeaveApplicationType = {
  applied_on?: string;
  approval_status?: any[];
  approver_details?: any[];
  designation_id?: number;
  duration?: number;
  employee_id?: string;
  end_date?: string;
  entity_id?: string;
  id?: number;
  is_first_half?: boolean;
  is_lop?: boolean;
  leave_type?: string;
  leave_sub_type?: string;
  leaves_split?: any;
  name?: string;
  project_id?: number;
  project_name?: string;
  reason?: string;
  start_date?: string;
  status?: string;
  storage_prefixes?: any[];
  sub_project_id?: number;
  sub_project_name?: string;
  team_id?: number;
  lead_access_level?: number;
  user_access_type?: string;
  lop_conversion_status?: string;
};

export type ILeaveListState = {
  leaves: ILeaveApplicationType[];
  lop_leaves: ILeaveApplicationType[];
  admin_leaves: ILeaveApplicationType[];
  leave_approval_types: any[];
  employees: any[];
};

export type ILeaveActionCreator = {
  type: string;
  payload: ILeaveApplicationType;
};

export enum ITeamActionTypes {
  FETCH_TEAM_LIST_REQUEST = "FETCH_TEAM_LIST_REQUEST",
  FETCH_TEAM_LIST_SUCCESS = "FETCH_TEAM_LIST_SUCCESS",
  FETCH_TEAM_LIST_FAILURE = "FETCH_TEAM_LIST_FAILURE",
}

export type ITeamType = {
  id?: number;
  name?: string;
};

export type ITeamListState = {
  data: ITeamType[];
};

export type ITeamActionCreator = {
  type: string;
  payload: ITeamType;
};
